<egi-card class="text-center">
  <egi-info
    *ngIf="info"
    style="position: absolute; top: 10px; right: 10px"
    [info]="info"
  ></egi-info>
  <div
    class="text-nowrap text-primary"
    [ngClass]="{
      'font-xs': textSize === 'xs',
      'font-sm': textSize === 'sm',
      'font-md': textSize === 'md',
      'font-lg': textSize === 'lg',
      'font-xl': textSize === 'xl'
    }"
  >
    {{ main }}
  </div>
  <h3>{{ mainDesc }}</h3>
  <h5>
    {{ secondary }}
    {{ secDesc }}
  </h5>
</egi-card>
